import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.push.js";
import { Pagination } from '@/components/Pagination';
import request from '@/utils/request';
import { officialList } from '@/api';
import { mapMutations, mapState } from 'vuex';
// import { fileViewer } from '@/utils/utils'
export default {
  components: {
    Pagination: Pagination
  },
  data: function data() {
    return {
      questionList: [],
      pageNum: 1,
      pageSize: 10,
      // fileViewer: fileViewer,
      total: 0
    };
  },
  watch: {
    searchValue: function searchValue() {
      this.handleSearch();
    }
  },
  computed: _objectSpread({}, mapState(['searchValue'])),
  methods: _objectSpread(_objectSpread({}, mapMutations(['UPDATE_ARTICLE_URL'])), {}, {
    currentChange: function currentChange(pageNo) {
      this.pageNum = pageNo;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res, regExp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                pageNum: _this.pageNum,
                pageSize: _this.pageSize,
                catCodes: 'clinical_guideline',
                title: _this.searchValue
              };
              _context.next = 3;
              return request.get(officialList, {
                params: params
              });
            case 3:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _this.questionList = res.obj.rows || [];
              _this.total = res.obj.total || 0;
              if (_this.questionList.length) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              regExp = new RegExp(_this.searchValue, 'g');
              _this.questionList.map(function (item) {
                item.title = item.title.replace(regExp, "<span style=\"color: #21ADB9;\">".concat(_this.searchValue, "</span>"));
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    redirectUrl: function redirectUrl(id) {
      // this.UPDATE_ARTICLE_URL(url)
      this.$router.push({
        path: '/article',
        query: {
          id: id
        }
      });
    }
  }),
  mounted: function mounted() {
    this.handleSearch();
  }
};